module.exports = __webpack_public_path__ + "img/hero01__1615360120_203.109.44.209.74fce772.jpg";